import { render, staticRenderFns } from "./headdetails.vue?vue&type=template&id=7a7db8d4&scoped=true&"
import script from "./headdetails.vue?vue&type=script&lang=js&"
export * from "./headdetails.vue?vue&type=script&lang=js&"
import style0 from "./headdetails.vue?vue&type=style&index=0&id=7a7db8d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7db8d4",
  null
  
)

export default component.exports